import { Box, Card, CardContent, CircularProgress, Typography } from "@mui/material"

const LoadingCard = () => {
	return (
		<Card sx={{height: '100%'}}>
			<CardContent sx={{height: '100%'}}>
				<Box width={'100%'} height={'90%'} sx={{display: 'flex', alignItems: 'center', justifyContent:'center'}}>
					<CircularProgress size={'1.5rem'} sx={{padding: 1}}/>
					<Typography>Loading</Typography>
				</Box>
			</CardContent>
		</Card>
	)
}

export default LoadingCard